// Slugs must match backend/src/modules/rooms/chat.types.ts's EMOTE_PRESETS
// exactly — the server validates against that list, this is purely the
// glyph shown per slug (the phrase itself comes from i18n: online.chat.emotes.<slug>).
export const EMOTE_PRESETS = [
    { slug: 'gg', emoji: '🤝' },
    { slug: 'nice', emoji: '👍' },
    { slug: 'oops', emoji: '😬' },
    { slug: 'thanks', emoji: '🙏' },
    { slug: 'hurry', emoji: '⏩' },
    { slug: 'lol', emoji: '😂' },
    { slug: 'wow', emoji: '😮' },
    { slug: 'sorry', emoji: '😔' },
];
